/*
 * <copyright company="Argenbright Innovations Lab">
 *        copyright (c) Argenbright Innovations Lab, an Argenbright Holdings Company.  All rights reserved.
 * </copyright>
 */

import { MediaType } from '../../../../Shared/Constants/App';

export interface IMediaAttachment {
  url: string;
  mdAttachmentType: 'Image' | 'Video' | 'Document';
  fileExtension?: string;
}

export interface MediaPopupState {
  isOpen: boolean;
  images: IMediaAttachment[];
  videos: IMediaAttachment[];
  documents: IMediaAttachment[];
  mediaType: MediaType;
  currentIndex: number;
  hasSignedApproval: boolean | null;
  scWorkOrderId: string | null;
}

export const initialMediaPopupState: MediaPopupState = {
  isOpen: false,
  images: [],
  videos: [],
  documents: [],
  mediaType: MediaType.Photo,
  currentIndex: 0,
  hasSignedApproval: null,
  scWorkOrderId: null,
};

export interface OpenMediaPopupParams {
  type: MediaType;
  photos: IMediaAttachment[];
  videos: IMediaAttachment[];
  pdfs: IMediaAttachment[];
  hasSignedApproval: boolean | null;
  scWorkOrderId: string | null;
  index?: number;
}
